import { Expose, Type } from 'class-transformer';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

export class UserListEntity extends BaseEntity {
    @Expose()
    @Type(() => UserEntity)
    public users: UserEntity[];
}
